module.exports = __webpack_public_path__ + "img/VENEZIA.1238dbbb.png";